export { default, links } from "/Users/danhey/github/rabbits/app/routes/index.tsx";